import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactNode, useState } from "react";
import { Modal, ModalContent, Button, ModalFooter } from "@heroui/react";

function InfoModal({
    children,
    trigger,
}: {
    children: ReactNode;
    trigger?:
        | ReactNode
        | ((setShowModal: (showModal: boolean) => void) => ReactNode);
}) {
    const [showModal, setShowModal] = useState(false);

    return (
        <div>
            {trigger ? (
                typeof trigger === "function" ? (
                    trigger(setShowModal)
                ) : (
                    trigger
                )
            ) : (
                <Button
                    isIconOnly
                    onPress={() => setShowModal(true)}
                    size="sm"
                    variant="light"
                    color="primary"
                    className="cursor-pointer"
                >
                    <FontAwesomeIcon icon={faInfoCircle} />
                </Button>
            )}

            <Modal isOpen={showModal} onClose={() => setShowModal(false)}>
                <ModalContent>
                    {children}
                    <ModalFooter>
                        <div className="flex flex-row justify-center">
                            <Button
                                size="sm"
                                color="primary"
                                onPress={() => setShowModal(false)}
                            >
                                Close
                            </Button>
                        </div>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </div>
    );
}

export default InfoModal;
